import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant22PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black }, ref)=>jsx("svg", {
        viewBox: "0 0 628 876",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M334.717 70.352c-60.758 24.617-126.208 46.284-177.853 87.609-46.105 36.902-87.117 92.032-86.715 154.533.313 52.895 34.132 105.255 83.99 122.991 33.998 12.063 73.044 6.031 102.486-14.564 25.509-17.915 40.744-45.39 55.933-71.794 15.413-26.715 33.418-49.947 61.518-64.288 25.331-12.911 55.487-16.842 82.918-9.292 32.926 9.069 60.044 33.775 77.467 63.171 14.52 24.482 23.098 52.717 22.785 81.176-.625 53.342-34.936 96.141-78.003 124.242-27.252 17.736-57.632 30.067-88.19 41.146-32.479 11.75-67.639 23.812-87.564 52.047-35.517 50.26-4.11 113.431-1.385 168.025",
            stroke: color,
            strokeWidth: 140,
            strokeMiterlimit: 10,
            strokeLinecap: "round"
        })
    }));

export { Variant22PathwayIllustration as default };
